import {Directive, Inject} from "@angular/core";
import {AddressComponent, FellOfferJourneyPushDataResponse, FelloOfferJourneyType, FelloVisitorUserType} from "fello-model";
import {take, takeUntil, tap} from "rxjs/operators";
import {OfferJourneyService} from "../../services/offer-journey/offer-journey.service";
import {FELLO_JOURNEY_TASK_ID} from "../../injection-token";
import {mixinDestroyable} from "fello-common";
import {environment} from "../../../../../environments/environment";
import {combineLatest} from "rxjs";
import {Params} from "@angular/router";
import {pick} from "lodash-es";

@Directive()
export class QuestionCardDirective extends mixinDestroyable(class {}) {
  offerJourney: FellOfferJourneyPushDataResponse;
  editMode = false;
  journeyType: FelloOfferJourneyType;
  FelloOfferJourneyType = FelloOfferJourneyType;

  constructor(public offerJourneyService: OfferJourneyService, @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string) {
    super();
    this.offerJourneyService.felloOfferJourney
      .pipe(
        takeUntil(this.isDestroyed),
        tap(offerJourney => {
          this.offerJourney = offerJourney;
          this.journeyType = offerJourney.journeyType;
        })
      )
      .subscribe();
  }

  get exitBtnTitle(): string {
    const exitBtnTitle = this.offerJourneyService.activatedRoute.snapshot.queryParamMap.get("exitBtnTitle");
    if (exitBtnTitle) {
      return exitBtnTitle;
    }

    const forcedUserType = this.offerJourneyService.activatedRoute.snapshot.queryParamMap.get("userType");
    if (forcedUserType) {
      if (forcedUserType === FelloVisitorUserType.AGENT) {
        return "Go to Fello Connect";
      }
      if (forcedUserType === FelloVisitorUserType.HOME_OWNER) {
        return "Go to Dashboard";
      }
    }
    return "Go to Dashboard";
  }

  goToDashboard(): void {
    combineLatest([this.offerJourneyService.felloOfferJourney, this.offerJourneyService.activatedRoute.queryParamMap])
      .pipe(
        take(1),
        tap(([offerJourney, queryParamMap]) => {
          window.top?.postMessage(
            {
              taskId: this.taskId,
              source: "offer-journey"
            },
            "*"
          );
          // const {first, last} = StringUtils.splitFullName(offerJourney.vars.userFullName ?? "");
          window.postMessage(
            {
              source: "fello",
              type: "journeyCompletion",
              content: {
                address: pick(offerJourney.addressComponent, [
                  "secondaryNumber",
                  "secondaryDesignator",
                  "county",
                  "doorNumber",
                  "street",
                  "city",
                  "state",
                  "zip",
                  "fullAddress",
                  "latitude",
                  "longitude"
                ] as (keyof AddressComponent)[]),
                // firstName: first,
                // lastName: last,
                email: offerJourney.vars.userEmail
                // phone: offerJourney.vars.userPhone
              }
            },
            window.location.origin
          );
          if (window.top === window.self) {
            const forcedUserType = queryParamMap.get("userType");
            const exitURL = queryParamMap.get("exitURL");
            if (exitURL) {
              return window.location.replace(exitURL);
            }
            if (forcedUserType === FelloVisitorUserType.AGENT) {
              return window.location.replace(this.getConnectSignUpUrl());
            }
            const queryParams: Params = {};
            queryParamMap.keys.forEach(key => {
              if (!["exitURL", "userType"].includes(key)) {
                queryParams[key] = queryParamMap.get(key);
              }
            });
            // if (formSubmitted) {
            //   queryParams.formSubmitted = true;
            // }
            const urlTree = this.offerJourneyService.router.createUrlTree(["/dashboard", offerJourney.propertyId], {
              queryParams,
              queryParamsHandling: "merge"
            });
            window.location.replace(urlTree.toString());
          }
        })
      )
      .subscribe();
  }

  private getConnectSignUpUrl(): string {
    const agentConnectUrl = new URL(environment.felloConnectBaseUrl);
    agentConnectUrl.pathname = `auth/signup`;
    return agentConnectUrl.toString();
  }

  goToHiFello(): void {
    window.location.href = environment.hiFelloBaseUrl;
  }

  goToFelloConnect(): void {
    window.location.href = environment.felloConnectBaseUrl;
  }

  toggleEdit(): void {
    this.editMode = !this.editMode;
  }
}
